import { Component, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { ClientDashboardGraphSubTypes } from 'src/app/core/enums/client-dashboard-graph-sub-types.enum';
import { ClientDashboardGraphTypes } from 'src/app/core/enums/client-dashboard-graph-types.enum';
import { HydrationService } from 'src/app/core/services/login/hydration.service';
import { DashboardTilesService } from 'src/app/core/services/nowaccount/dashboard/dashboard-tiles.service';
import { Alert } from 'src/app/core/types/alert.type';
import { DashboardGridItem } from 'src/app/core/types/dashboard-grid-item.type';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  navTiles: { title: string; alert: Alert; routerHref: string }[] = [];
  gridTiles: DashboardGridItem[] = [];
  dialogTiles: DashboardGridItem[] = [];
  graphTypesEnum = ClientDashboardGraphTypes;
  graphSubTypesEnum = ClientDashboardGraphSubTypes;
  dialogSelectedItem: DashboardGridItem | null = null;
  loading = true;

  constructor(
    private hs: HydrationService,
    private dts: DashboardTilesService,
  ) {}

  async ngOnInit(): Promise<void> {
    //console.log('DashboardComponent HydrateAccountStore');
    await Promise.allSettled([
      this.dts.getUserAssignedDashboardTiles('Client'),
    ]);

    this.navTiles = this.dts.navTiles;
    this.gridTiles = this.dts.gridTiles;
    this.dialogTiles = this.dts.dialogTiles;
    this.loading = false;
  }

  dialogSelectEventListener(gridItem: DashboardGridItem) {
    // grab dialog's version of selected grid tile
    // eslint-disable-next-line prefer-destructuring
    const len = this.dialogTiles.length;
    for (let i = 0; i < len; i += 1) {
      const dialogTile = this.dialogTiles[i];
      if (dialogTile.id === gridItem.id) {
        this.dialogSelectedItem = dialogTile;
        break;
      }
    }
    console.log('new dialogSelectedItem, ', this.dialogSelectedItem);
  }

  dialogChangeEventListener(change: any) {
    this.dialogSelectedItem = change;
  }

  initializeDialogDataEventListener(gridItem: {
    id: string;
    title: string;
    data: any;
  }) {
    const len = this.dialogTiles.length;
    for (let i = 0; i < len; i += 1) {
      if (this.dialogTiles[i].id === gridItem.id) {
        this.dialogTiles[i].title = gridItem.title
          ? cloneDeep(gridItem.title)
          : this.dialogTiles[i].title;
        this.dialogTiles[i].data = cloneDeep(gridItem.data);
        break;
      }
    }
  }
}
